<template>
    <!-- <v-footer></v-footer> -->
    <v-footer absolute class="text-center d-flex flex-column" color="footer">
        <div style="width:95%">

            <div class="endereco text-caption text-right">
                Av. Colares Moreira, 443, Renascença II • CEP 65075-441 - São Luís (MA) - Brasil
                <div>
                    (98) 4009-7090
                </div>
            </div>

            <v-divider class="my-4"></v-divider>

            <div class="links-institucionais">
                <v-row>
                    <v-col cols="12" sm="4" md="4"
                        v-for="categoria, ci in Array.from(new Set(computedLinks.map(i => i.categoria)))" :key="'links-categoria-'+ci">
                        <div class="text-left text-h6">
                            {{categoria}}
                            <v-divider class="mr-12"></v-divider>
                        </div>
                        <div v-for="link, index in computedLinks.filter(i => i.categoria==categoria)"
                            :key="'col-link-'+index">
                            <v-list-item two-line :href="link.link" class="text-left mx-0 px-0"
                                target="_blank" elevation="0" density="compact">
                                <v-list-item-title class="text-caption">
                                    <v-icon-small class="mb-1">mdi-web</v-icon-small>
                                    {{link.label}}
                                </v-list-item-title>
                            </v-list-item>
                        </div>
                    </v-col>
                </v-row>
            </div> 

            <v-divider class="my-2"></v-divider>
            <div class="logos pa-2">
                <v-row>
                    <v-col cols="12" offset-sm="1" sm="4" class="logo-UNDB">
                        <div class="text-center">
                            <div class="logo-instituicao" style="height: 88px;align-content: center;">
                                <v-img src="logo-undb.png"
                                    width="150">
                                </v-img>
                            </div>
                            <div>
                                <v-btn-small v-for="l in socialsundb" :key="l.link" :href="l.link" icon color="transparent">
                                    <v-icon>{{l.icon}}</v-icon>
                                </v-btn-small>
                            </div>
                        </div>
                    </v-col>

                    <v-col cols="12" offset-sm="1" sm="4" class="logo-DB">
                        <div class="text-center">
                            <div class="logo-instituicao">
                                <v-img src="logo-db-roxo.png"
                                    width="150">
                                </v-img>
                            </div>
                            <div>
                                <v-btn-small v-for="l in socialsdb" :key="l.link" :href="l.link" icon color="transparent">
                                    <v-icon>{{l.icon}}</v-icon>
                                </v-btn-small>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </div>
            <v-divider class="my-4"></v-divider>
            <div>
                <small>{{ new Date().getFullYear() }} — <strong>Intranet - Grupo Dom Bosco</strong></small>
            </div>
        </div>
    </v-footer>
</template>
<script>
export default {
    data: () => ({
        socialsdb: [
            { icon: 'mdi-web', link: 'https://www.dbosco.com.br' },
            { icon: 'mdi-linkedin', link: 'https://www.linkedin.com/company/dom-bosco-ma' },
            { icon: 'mdi-instagram', link: 'https://www.instagram.com/domboscosaoluis' },
        ],
        socialsundb: [
            { icon: 'mdi-web', link: 'https://www.undb.edu.br' },
            { icon: 'mdi-linkedin', link: 'https://www.linkedin.com/school/undb' },
            { icon: 'mdi-instagram', link: 'https://www.instagram.com/undboficial' },
            { icon: 'mdi-facebook', link: 'https://www.facebook.com/undboficial' },
            { icon: 'mdi-twitter', link: 'https://twitter.com/undboficial' },
            { icon: 'mdi-youtube', link: 'https://www.youtube.com/channel/UCywxgwra4HfhV7T7BQUfB2g' },
        ],
    }),
    computed:{
        computedLinks(){
            return this.$verify.links_uteis
        }
    },
}
</script>
<style scoped>
.logo-instituicao {
    background-color: white;
    padding: 10px 10px;
    border-radius: 5px;
    text-align: -webkit-center;
}
</style>